import { render, staticRenderFns } from "./redEnvelope.vue?vue&type=template&id=1bf29d21&scoped=true&"
import script from "./redEnvelope.vue?vue&type=script&lang=js&"
export * from "./redEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./redEnvelope.vue?vue&type=style&index=0&id=1bf29d21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf29d21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf29d21')) {
      api.createRecord('1bf29d21', component.options)
    } else {
      api.reload('1bf29d21', component.options)
    }
    module.hot.accept("./redEnvelope.vue?vue&type=template&id=1bf29d21&scoped=true&", function () {
      api.rerender('1bf29d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/components/redEnvelope.vue"
export default component.exports